import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../components/Modal';
import PropTypes from 'prop-types';

function FormSeleccionarPeriodo(props) {
    const {
        periodoL,
    } = props;

    const [id, setId] = useState("");

    const handleChange = e => {
        setId(e.target.value);
    }
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const [estadoModal, cambiarEstadoModal] = useState(true);

    return (
        <div className='container'>
            <Modal
                estado={estadoModal}
                cambiarEstado={cambiarEstadoModal}
                titulo="Seleccionar Periodo"
                botonCerrar="false"
            >

                {periodoL &&
                    <div className="form-floating">
                        <select className="form-select" id="periodo"
                            value={id} onChange={handleChange} autoFocus >
                            <option selected>Seleccionar...</option>
                            {periodoL.map(mes =>
                                <option key={mes.value} value={mes.value}>{mes.label}</option>)
                            }

                        </select>
                        <label className='form-label' htmlfor="periodo">Periodo</label>
                    </div>
                }
                <br />
                <Contenido>
                    {periodoL.length > 0 && id_emp[4] === 'contabilidad' && 
                        (id &&
                        <a
                            href={`/#/contabilidad/${id_emp[5]}/polizas/${id}`}
                            className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                        
                    }
                    {periodoL.length > 0 && id_emp[4] === 'libros_contables' && 
                        (id &&
                        <a
                            href={`/#/libros_contables/${id_emp[5]}/polizas/${id}`}
                            className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                        
                    }
                </Contenido>
            </Modal>
        </div>
    );

}
FormSeleccionarPeriodo.propTypes = {
    periodoL: PropTypes.string.isRequired,
};

export default (FormSeleccionarPeriodo);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;